<template>
  <b-row align-h="between" no-gutters class="py-4 text-light">
    <b-col>{{ from }} - {{ to }}</b-col>
    <b-col class="text-right">{{ total }} {{ text }}</b-col>
  </b-row>
</template>

<script>
/**
 * @description Permet d'afficher un sous-titre de pagination générique
 * @author Maxime Boisvert
 * @vue-props {Number} from - Le numéro du premier élément dans la pagination actuelle
 * @vue-props {Number} to - Le numéro du dernier élément dans la pagination actuelle
 * @vue-props {Number} total - Le nombre total d'éléments
 * @vue-props {String} text - Description de l'élément
 */
export default {
  name: "GenericPaginationSubHeader",
  props: {
    from: {
      type: Number,
      required: true
    },
    to: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  }
};
</script>
